/**
 * Utility function to generate image URLs using environment variable
 * @param {string} imagePath - The image filename or path
 * @param {string} folder - The folder name ('imgPro' or 'imgWeb')
 * @returns {string} Complete image URL
 */
export const getImageUrl = (imagePath, folder = 'imgPro') => {
    if (!imagePath) return '';

    const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL || '';
    return `${baseUrl}/front-style/${folder}/${imagePath}`;
};
